
// Set Global GA4ID
window.ga4_id = PM.Get("Application", "ga4");

// Call google analytics code
function loadGA4() {
	//console.log('GA4 Devrede');
	window.dataLayer = window.dataLayer || [];
	window.gtag = function(){dataLayer.push(arguments);}
	// Send PageView	
	gtag('js', new Date());
	gtag('config', ga4_id);
	
	$(document).ready(function(){
		const _script = document.createElement("script");
		_script.src="https://www.googletagmanager.com/gtag/js?id="+ga4_id;
		_script.async = 1;
		
		document.body.appendChild(_script);
	});
}

// On PM Ready
(function(){
	// Check Dnt
	var isDntActive = window && window.navigator && window.navigator.doNotTrack ? window.navigator.doNotTrack === '1' : false;

	// Check in private page
	var isPrivate = ([ 'sifre_degistir' ].indexOf(PM.ActionPage) > -1);
	var isLighthouse = (navigator.userAgent.indexOf("Lighthouse") == -1 && navigator.userAgent.indexOf("moto g power") == -1);

	// Check ga id is alive
	if (!ga4_id || isDntActive || isPrivate || !isLighthouse) {
		window.gtag = function(){};
		return;
	}

	// Parse query string
	var qs = window.location.search.substring(1) ? getQueryVariable(window.location.search.substring(1)) : {};

	// So load global ga
	loadGA4();
	//console.log('google analytics deverde ga4js');
	
	PM.OnPage("arama_sonuclari", function(){
		gtag("event", "search", {
		  search_term: qs.word
		});
	});

	$(".urun a").on("click", function(e){

		let params = undefined;
		
		const target = e.target.closest("a");
		
		params = $(target).attr("href") || $(target).attr("onclick")
		
		if (params != null && (params = params.match(/\?islem=sepete_ekle2.*uid=([0-9]+)|[PM\.HemenAl|hemenal_fonksiyon]\(([0-9]+)\)/i)) !== null) {
			const product = $(target).closest(".urun");
			const instance =  {
				item_id: params[1],
				item_name: $(product).find(".urun_ismi").text().trim(),
				price: parseFloat($(product).find(".urun_kdvdahil_fiyati,.urun_fiyati").last().text().trim().replace(/([\d\.,]+).*/,"$1").replace(".","").replace(",",".")),
				quantity: 1,
			}
			
			gtag('event', 'add_to_cart', {
				currency: "TRY",
				value: instance["price"],
				items: [instance]
			});
		}

	});


	// On Add Cart at product detail
	PM.on("add.cart", function(params) {
		//console.log("add.cart", params);

		PM.OnPage("urun_detay", function() {
			var product = {
				item_id : params.urun_id,
				item_name : $("#PM_urun_detayi h1.urun_ismi").text(),
				price : google_tag_params.ecomm_totalvalue,
				quantity : $(".urun_secenekleri > table:eq(0) tr td input#urun_miktar_secenekleri").length ? parseInt($(".urun_secenekleri > table:eq(0) tr td input#urun_miktar_secenekleri").val(), 10) : 1,
			}
			gtag('event', 'add_to_cart', {
				value: product.price * product.quantity,
				items: [product]
			});
		});

		PM.OnPage("sepet_detayi", function() {
			gtag('event', 'add_to_cart', {
				items: [{
					item_id : params.urun_id,
				}]
			});
		});

	});

	// On Remove Cart at product detail
	PM.on("remove.cart", function(params) {
		//console.log("remove.cart", params);
	
			window.gtag('event', 'remove_from_cart', {
				items: [
				{
					item_id: params.id,
					item_name: params.name,
					quantity: params.quantity
					//todo : devamı gelecek
				}
				]
			});
	});


	// On new user register
	PM.on("new.user", function(user) {
		//console.log("new.user", user);
		var uye_tip = {"1": "Bireysel", "2": "Kurumsal"};
		gtag("event", "sign_up", {
		  user_type: uye_tip[user.uye_tip],
		});
		//ga('send', 'event', { eventCategory: 'Üye', eventAction: 'Yeni Kayıt', eventLabel: uye_tip[user.uye_tip] });
	});

	// On tab view
	PM.on("view.tab", function(tab_name) {
		//console.log("view.tab", tab_name);
		gtag("event", "view_tab", {
		  tab_name: tab_name,
		});
		//ga('send', 'event', { eventCategory: 'Ürün', eventAction: 'Sekme', eventLabel: tab_name });
	});

	// On daraltma
	$("#urun_siralama_secenekleri").on("change", function(e){
		//console.log("sıralama", this.selectedOptions[0].text);
		gtag("event", "sort", {
		  sort_by: this.selectedOptions[0].text,
		});
		//if (this.selectedOptions.length) ga('send', 'event', { eventCategory: 'Ürün', eventAction: 'Sıralama', eventLabel: this.selectedOptions[0].text });
	});

	// On Page Product Detail
	PM.OnPage("urun_detay", function(params){
		
		try {
			const schema = JSON.parse($("script#pm_schema").text());
			
			window.gtag("event", "view_item", {
			  currency: schema.offers.priceCurrency,
			  value: schema.offers.price,
			  items: [
				{
				  item_id: schema.sku,
				  item_name: schema.name,
				  index: 0,
				  item_brand: schema.brand.name,
				  price: schema.offers.price,
				  quantity: 1
				}
			  ]
			});
		
		} catch (error) {
			return;
		}
	});

	// On Cart View set local storage
	PM.OnPage("sepet_detayi", function(params){

		var products = getProductFromNode();
		
		window.localStorage.setItem("ga_sepet", JSON.stringify(products));
		
		
		if (products.length != 0) {
			//console.log(products);
			window.gtag("event", "view_cart", {
			  currency: "TRY",
			  value: products.reduce((sum,next)=>sum+(next.price*next.quantity),0),
			  items: products.map((item)=>({
				  item_id: item.id,
				  item_name: item.name,
				  price: item.price,
				  quantity: item.quantity,

			  }))
			});
		}
	});

	// On Order Step 1
	PM.OnPage("order_step_1", function(params){
		//console.log("order_step_1", params);
		var products = JSON.parse(window.localStorage.getItem("ga_sepet"));
		if (products !== null && products.length != 0) {
			window.gtag("event", "add_shipping_info", {
			  currency: "TRY",
			  value: products.reduce((sum,next)=>sum+(next.price*next.quantity),0),
			  items: products.map((item)=>({
				  item_id: item.id,
				  item_name: item.name,
				  price: item.price,
				  quantity: item.quantity,

			  }))
			});
		}
	});

	// On Order Step 2
	PM.OnPage("order_step_2", function(params){
		//console.log("order_step_2", params);
		PM.on("process.checkout", function(params){
			//console.log("process", params);
			var _option = params['sot'].replace('os_', '');
			switch (true) {
				case (_option == 'kredi_karti'): _option = ({ "1": "Kredi Kartı Peşin", "2": "Kredi Kartı Taksit", "3": "BKM Express" })[params["kk_odeme_tipi_secimi"]]; break;
				case (_option == 'havale'): _option = "Havale"; break;
				case (_option == 'kapipda_odeme'): _option = "Kapıda Ödeme"; break;
				default: _option = _option; break;
			}
			
				var products = JSON.parse(window.localStorage.getItem("ga_sepet"));
				if (products !== null && products.length != 0) {
					window.gtag("event", "add_payment_info", {
					  currency: "TRY",
					  value: products.reduce((sum,next)=>sum+(next.price*next.quantity),0),
					  payment_type: _option,
					  items: products.map((item)=>({
						  item_id: item.id,
						  item_name: item.name,
						  price: item.price,
						  quantity: item.quantity,

					  }))
					});
				}
		});
	});

	// On Order Step 3
	PM.OnPage("order_step_3", function(params){
			//console.log("order_step_3", params);
		var products = JSON.parse(window.localStorage.getItem("ga_sepet"));
		if (products !== null && products.length != 0) {
			window.gtag("event", "begin_checkout", {
			  currency: "TRY",
			  value: products.reduce((sum,next)=>sum+(next.price*next.quantity),0),
			  items: products.map((item)=>({
				  item_id: item.id,
				  item_name: item.name,
				  price: item.price,
				  quantity: item.quantity,

			  }))
			});
		}
	});

	// On Order End
	PM.OnPage("siparis_sonu", function(params){
		//console.log("siparis_sonu", params);
		var products = JSON.parse(window.localStorage.getItem("ga_sepet")) || window.basket || [];
		if (typeof google_ecommerce_option == 'undefined') return;
		
		gtag("event", "purchase", {
			transaction_id: qs['oid'],
			value: parseFloat(google_ecommerce_option.revenue.replace('.', '').replace(',', '.')),
			tax: parseFloat(google_ecommerce_option.tax.replace('.', '').replace(',', '.') || '0.00'),
			shipping: parseFloat(google_ecommerce_option.shipping.replace('.', '').replace(',', '.') || '0.00'),
			currency: "TRY",
			method: google_ecommerce_option['option'],
			items: products.map((item)=>({
				  item_id: item.id,
				  item_name: item.name,
				  price: item.price,
				  quantity: item.quantity,

			 }))
		});
		window.localStorage.removeItem("ga_sepet");
		
	});


})();

// Return product data
function getProductFromNode(el) {
	
		return $(".sepet_urunler tbody tr").map((i, e) => ({
			id : $('a[href*="-pmu"]', e).attr("href").replace(/.*pmu([0-9]+)/i, "$1"),
			price : parseFloat($('td[data-price-wt]',e).data('price-wt').replaceAll('.','').replace(',','.')),
			name : $('a[href*="-pmu"]', e).attr('title').trim(),
			quantity : parseInt($('input#birim', e).val(),10)
		})).toArray()
}

// Parse query string
function getQueryVariable(query) {
	var result = {};
	var vars = query.split('&');
	for (var i = 0; i < vars.length; i++) {
	   var pair = vars[i].split('=');
		try {
			result[decodeURIComponent(pair[0])] = decodeURIComponent(unescape(pair[1]).replace(/\++/gi, '%20')).trim();
		} catch (err) {
			result[pair[0]] = pair[1];
		}
	}
	return result;
}



